export default __webpack_public_path__ + "static/media/authereumIcon.b5b4e154.svg";